import React from 'react'
import './footer.css'

function Footer({ background }) {
    const unlisten = () => {
        window.scrollTo(0,0);
    }

  return (
    <div className={`footer ${background}`}>
        <div className='scroll_to_top'>
            <i class='bx bx-chevron-up' onClick={unlisten}></i> 
        </div>

        <div className='contact_info'>
            <h5>Email us for more information: ciruandanthony@gmail.com</h5>
        </div>

        <div className='copyright'>
            <p className="copyright_details">
                {`Copyright © ${new Date().getFullYear()} Wanjiru Waititu & Karungu Anthony. `}
                {`Proudly created by `}
                <a color="inherit" href="https://victor-githui.netlify.app/" target="_blank" rel="noreferrer">
                    Victor Githui
                </a>{' '}
                
            </p>
        </div>
        
    </div>
  )
}

export default Footer